import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { Fragment, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FaCheck, FaTimes } from "react-icons/fa";
import { PROFILE_WINNERHISTORY } from "../../constant/menuAndProfile";
import { IReduxStateData } from "../../interfaces/redux";
import { useSelector } from "react-redux";
import { deal_type } from "../../constant/deal";

interface ICertificateList {
  // dealList: Array<any>,
  dealDetail: Array<any>;
  selectedDeal: any;
  winnerList: Array<any>;
  // changeActiveDeal: (arg0: string, arg1: string) => void,
  // changeDealData?: (arg0: Array<any>) => void,
  refreshData?: () => void;
  openSelectOption: (open: boolean) => void;
}
interface IData {
  index?: number;
  user?: string;
  match_title?: string;
  tp_name?: string;
  award_value?: string;
  award_start_date?: string;
  award_end_date?: string;
  is_redeemed?: number;
  redeemed_by?: string;
}
export const CertificateList = (props: ICertificateList) => {
  const [results, setResults] = useState<IData[]>([]);
  const [finalData, setFinalData] = useState<(string | number | undefined)[][]>(
    []
  );
  const [currentDealDetail, setCurrentDealDetail] = useState<any>({});
  const [changeFlag, setFlag] = useState<Boolean>(true);
  const globalState = useSelector((state: IReduxStateData) => state);
  const selectedLanguage = globalState?.selectedLang;
  const columns = [
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].no,
      options: { filter: false, fullWidth: true },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].user,
      options: { filter: false },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].match,
      options: { filter: true },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].team_player,
      options: { filter: true },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].offer,
      options: { filter: true },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].offer_from,
      options: { filter: false },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].offer_to,
      options: { filter: false },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].redeemed,
      options: {
        filter: true,
        customBodyRender: (
          value: any,
          tableMeta: { rowData: any },
          updateValue: any
        ) => {
          return <Fragment>{value ? <FaCheck /> : <FaTimes />}</Fragment>;
        },
      },
    },
    {
      name: PROFILE_WINNERHISTORY[selectedLanguage].redeemed_by,
      options: { filter: true },
    },
  ];
  const options: MUIDataTableOptions = {
    filter: true,
    filterType: "dropdown",
    responsive: "simple",
    jumpToPage: false,
    fixedSelectColumn: false,
    fixedHeader: false,
    pagination: false,
    selectableRows: "none", // used to hide selction of rows
    // search: true,
    // download: true,
    // print: true,
    // viewColumns: true,
    // filter: true,
    // filterType: "dropdown",
    // responsive: "vertical",
    onTableChange: (action, state) => {
      console.log(action);
      console.dir(state);
    },
  };
  const getNameFItemsList = (detailObj: any) => {
    return detailObj?.match_title || "";
  };
  const getSubNameFItemsList = (detailObj: any) => {
    return detailObj?.tp_name || "";
  };
  const getImageFItemsList = (detailObj: any) => {
    return detailObj?.deal_image || "/assets/images/player-banner.png";
  };
  useEffect(() => {
    if (props.winnerList) {
      let data: any[] = [];
      let array: (string | number | undefined)[][];
      // eslint-disable-next-line array-callback-return
      props?.winnerList?.map((winnerData: any, index: number) => {
        data.push({
          index: index + 1,
          user: winnerData?.user_name,
          match_title: winnerData?.match_title,
          tp_name: winnerData?.tp_name,
          award_value: winnerData?.award_value,
          award_start_date:
            new Date(winnerData?.award_start_date).toLocaleTimeString() +
            " " +
            new Date(winnerData?.award_start_date).toLocaleDateString(),
          award_end_date:
            new Date(winnerData?.award_end_date).toLocaleTimeString() +
            " " +
            new Date(winnerData?.award_end_date).toLocaleDateString(),
          is_redeemed: winnerData?.is_redeemed,
          redeemed_by: winnerData?.redeemed_by,
        });
      });
      setResults(data);
      if (data) {
        if (data.length) {
          array = data?.map((result) => [
            result.index,
            result.user,
            result.match_title || "",
            result.tp_name || "",
            result?.award_value || "",
            result?.award_start_date || "",
            result?.award_end_date || "",
            result?.is_redeemed || "",
            result?.redeemed_by,
          ]);
          // data = array;
          setFinalData(array);
        } else {
          setFinalData([]);
        }
      }
    }
    setFlag(!changeFlag);
  }, [props.winnerList]);
  useEffect(() => {
    if (props?.dealDetail && props?.selectedDeal) {
      props?.dealDetail?.forEach((dData: any) => {
        if (dData?.uuid === props?.selectedDeal) {
          setCurrentDealDetail(dData);
          setFlag(!changeFlag);
        }
      });
    }
  }, [props?.dealDetail, props?.dealDetail.length, props?.selectedDeal]);

  console.log("currentDealDetail >", currentDealDetail);
  return (
    <Fragment key={changeFlag ? "true" : "false"}>
      <div className="right-side-header-main">
        <div className="right-side-header">
          {PROFILE_WINNERHISTORY[selectedLanguage].winner_history}
        </div>
      </div>
      <hr />
      <Row>
        <Col sm={12} className="d-flex align-items-center justify-content-end">
          <div className="material-dropdown-select">
            {/* <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic">Select Stastics</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {props?.dealList && props?.dealList?.map((data: any, index: number) => {
                                    return data?.deal_list?.map((listData: any) =>
                                        <Dropdown.Item eventKey={index.toString()} active={data.main_deal_uuid === props.selectedDeal?.main_deal_uuid && listData.deal_uuid === props.selectedDeal?.deal_uuid ? true : false} onClick={() => { props.changeActiveDeal(data.main_deal_uuid, listData.deal_uuid) }}>{data?.match_title + "-" + listData?.tp_name}</Dropdown.Item>
                                    )
                                }
                                )}
                            </Dropdown.Menu>
                        </Dropdown> */}
            <Button
              onClick={() => {
                props.openSelectOption(true);
              }}
              variant="primary"
              className="btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16"
              autoFocus
            >
              {PROFILE_WINNERHISTORY[selectedLanguage].toggle_data}
            </Button>
          </div>
        </Col>
      </Row>
      {currentDealDetail && Object.keys(currentDealDetail).length ? (
        <Row className="justify-content-center pt-2 pt-sm-0">
          <Col
            sm={5}
            lg={4}
            className="card-column theme-background-green p-0 m-0 theme-border-green"
          >
            {currentDealDetail ? (
              <Fragment>
                <img
                  className="card-img theme-background-dark-green py-4 px-2"
                  alt=""
                  src={getImageFItemsList(currentDealDetail)}
                />
                <div className="card-image-overlay">
                  <div>
                    {/* <span className='image-wrapper'>
                                            <img className='image-rank' alt='' src='/assets/images/team-rank.svg' />
                                        </span> */}
                    {/* <span className='image-rank-number'>1</span> */}
                    <span className="image-team-wrapper mt-1 left-50">
                      <img
                        alt=""
                        className="team-name"
                        src="/assets/images/team-name.svg"
                      />
                      <span className="team-name-title theme-white line-clamp-1">
                        {getNameFItemsList(currentDealDetail)}
                      </span>
                    </span>
                  </div>
                  <div className="image-card-title">
                    <span className={`image-card-wrapper bottom`}>
                      <img
                        alt=""
                        className="image-title"
                        src="/assets/images/team-name.svg"
                      />
                      <span className="image-title-name theme-white line-clamp-1">
                        {getSubNameFItemsList(currentDealDetail)}
                      </span>
                    </span>
                    {/* {currentDealDetail?.is_player === 1 && currentDealDetail.player_jersey_number ?
                                                <span className='image-circle-wrapper'>
                                                    <img alt='' src='/assets/images/circle.svg' className='image-circle' />
                                                    <span className='circle'>{currentDealDetail.player_jersey_number}</span>
                                                </span>
                                                : null} */}
                  </div>
                </div>
              </Fragment>
            ) : null}
          </Col>
          {currentDealDetail?.is_player &&
          (currentDealDetail.is_player === deal_type["player_deal"] ||
            currentDealDetail.is_player === deal_type["team_deal"]) ? (
            <Col
              sm={7}
              lg={5}
              className="d-flex align-items-center justify-content-center pl-0"
            >
              <div className="beside-image">
                {currentDealDetail.is_player === deal_type["player_deal"] ? (
                  <Fragment>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .player_info_name
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.player_name}
                      </div>
                    </div>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .player_info_birthplace
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.player_birth_place}
                      </div>
                    </div>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .player_info_birthdate
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green">
                        {currentDealDetail?.player_date_of_birth
                          ? new Date(
                              currentDealDetail?.player_date_of_birth
                            ).toLocaleDateString()
                          : ""}
                      </div>
                    </div>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .player_info_position
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.player_position}
                      </div>
                    </div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {PROFILE_WINNERHISTORY[selectedLanguage].team_info_name}{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.team_name}
                      </div>
                    </div>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .team_info_full_name
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.team_fullname}
                      </div>
                    </div>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .team_info_nationality
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.team_flag ? (
                          <img
                            src="https://res.cloudinary.com/deq61wdj1/image/upload/v1753435731/lcd/player_country_flag/dominica_ru9u7k.png"
                            alt=""
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="d-flex bd-highlight">
                      <div className="p-1 w-50 bd-highlight">
                        {
                          PROFILE_WINNERHISTORY[selectedLanguage]
                            .team_info_owner
                        }{" "}
                        :
                      </div>
                      <div className="p-1 theme-green text-capitalize">
                        {currentDealDetail?.team_owner}
                      </div>
                    </div>
                  </Fragment>
                )}
                <div className="d-flex bd-highlight">
                  <div className="p-1 w-50 bd-highlight">
                    {PROFILE_WINNERHISTORY[selectedLanguage].league_name} :
                  </div>
                  <div className="p-1 theme-green text-capitalize">
                    {currentDealDetail?.league_name}
                  </div>
                </div>
              </div>
            </Col>
          ) : null}
        </Row>
      ) : null}
      <Row className="pt-2">
        <Col sm={12} className="react-table-kitchen-wrapper theme-dark-black">
          <div className="table-wrapper" style={{ flexGrow: 1 }}>
            {finalData ? (
              // <ThemeProvider theme={createTheme()}>
              <MUIDataTable
                title={""}
                data={finalData}
                columns={columns}
                options={options}
              />
            ) : // </ThemeProvider>
            null}
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};
